import endpoints from '@/constants/endpoints';
import axiosV2 from '@/data/api/axiosv2';
import { ITEMS_TABLE_PAGE_LIMIT } from '@/utils/constants';
import {
  CartApiResponse,
  CreateCartRequest,
  CreateCartResponse,
  GetCartDetailResponse,
} from '../model/cart/CartDto';

export const getCarts = async (
  pageNumber: number
): Promise<CartApiResponse> => {
  const endpoint = endpoints.cart.getCarts;
  const response = await axiosV2.get<CartApiResponse>(endpoint, {
    params: {
      limit: ITEMS_TABLE_PAGE_LIMIT,
      page: pageNumber,
    },
  });
  return response;
};

export const createCart = async (
  request: CreateCartRequest
): Promise<CreateCartResponse> => {
  const endpoint = endpoints.cart.createCart;
  const response: CreateCartResponse = await axiosV2.post(endpoint, request);
  return response;
};

export const publishCart = async (cartId: string): Promise<void> => {
  const endpoint = endpoints.cart.confirmCart.replace(':cartId', cartId);
  await axiosV2.post(endpoint);
  return;
};

export const updateCart = async (
  cartId: string,
  request: CreateCartRequest
): Promise<CreateCartResponse> => {
  const endpoint = endpoints.cart.updateCart.replace(':cartId', cartId);
  const response: CreateCartResponse = await axiosV2.post(endpoint, request);
  return response;
};

export const getCart = async (
  cartId: string
): Promise<GetCartDetailResponse> => {
  const endpoint = endpoints.cart.getCart.replace(':cartId', cartId);
  return await axiosV2.get(endpoint);
};

export const deleteCart = async (cartId: string): Promise<void> => {
  const endpoint = endpoints.cart.deleteCart.replace(':cartId', cartId);
  return await axiosV2.delete(endpoint);
};

export const duplicateCart = async (cartId: string): Promise<void> => {
  const endpoint = endpoints.cart.duplicateCart.replace(':cartId', cartId);
  await axiosV2.post(endpoint);
  return;
};
